import MapControlPopover from '../MapControlPopover';
import type { ReactNode } from 'react';

import ApplyIcon from 'components/icons/ApplyIcon';
import NoEntryIcon from 'components/icons/NoEntryIcon';

import useTranslation from './hooks/useTranslation';

import { DRAWING_MODE, TEST_ID } from './constants';
import type { Props } from './types';

const DrawingModeDropdown = ({ drawingMode, onDrawingModeChange, testId = TEST_ID }: Props) => {
    const { APPLY, NO_ENTRY } = useTranslation();

    const applyText = (
        <>
            <ApplyIcon />

            {APPLY}
        </>
    );
    const noEntryText = (
        <>
            <NoEntryIcon />

            {NO_ENTRY}
        </>
    );
    const drawingModeText: Record<DRAWING_MODE, ReactNode> = {
        [DRAWING_MODE.APPLY]: applyText,
        [DRAWING_MODE.NO_ENTRY]: noEntryText
    };

    const drawingModeIcon: Record<DRAWING_MODE, ReactNode> = {
        [DRAWING_MODE.APPLY]: <ApplyIcon />,
        [DRAWING_MODE.NO_ENTRY]: <NoEntryIcon />
    };

    const options = [
        { label: APPLY, value: DRAWING_MODE.APPLY },
        { label: NO_ENTRY, value: DRAWING_MODE.NO_ENTRY }
    ];

    return (
        <MapControlPopover
            displayIcon={drawingModeIcon[drawingMode]}
            displayText={drawingModeText[drawingMode]}
            onChange={onDrawingModeChange}
            options={options}
            testId={testId}
            value={drawingMode}
        />
    );
};

export default DrawingModeDropdown;
